import styled from 'styled-components';

export const LanguageSelectorBlock = styled.div<{ size: 'small' | 'medium' }>`
  display: flex;
  gap: 10px;
  & select,
  div {
    font-size: ${({ size }) => (size === 'small' ? '0.85rem' : '16px')};
  }
`;

export const LanguageSelector = styled.select`
  padding: 0;
  margin: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  box-shadow: none;
  color: #454545;
  cursor: pointer;
  display: inline-block;
  float: none;
  font-weight: 400;
  height: auto;
  line-height: 2;
  width: 85px;
`;

export const LanguageIcon = styled.div`
  display: inline-block;
  line-height: 2;
`;
